<div class="col-12 mb-3 text-white menuItem">
  @if (!menuItem!.children) {
  <a
    [routerLink]="menuItem?.route"
    (click)="slideMenuService.showed = false"
    [attr.aria-current]="isActive ? 'page' : null"
    [class.menuItem__link--active]="isActive"
    class="btn d-flex align-items-center justify-content-between w-100 menuItem__link"
  >
    <span class="d-flex align-items-center" [class.text-white]="!isActive">
      @if (menuItem!.icon) {
        <i class="material-icons me-2">
          {{ menuItem!.icon }}
        </i>
      }
      {{ menuItem!.title }}
    </span>
  </a>
  } @if (menuItem!.children) {
    <button
      (click)="isOpen = !isOpen"
      [attr.aria-expanded]="isOpen"
      [class.menuItem__link--groupActive]="hasActiveChild"
      class="btn d-flex align-items-center justify-content-between w-100 menuItem__link"
    >
      <span class="d-flex align-items-center text-white">
        @if (menuItem!.icon) {
          <i class="material-icons me-2">
            {{ menuItem!.icon }}
          </i>
        }
        {{ menuItem!.title }}
      </span>
      <i class="material-icons text-white">
        {{ isOpen ? "keyboard_arrow_down" : "chevron_right" }}
      </i>
    </button>
  } @if (menuItem!.children && isOpen) {
    <div>
      <div class="col-12 ps-4 pt-3">
        @for (menu of menuItem?.children; track menu.title) {
          <app-menu-item [menuItem]="menu"></app-menu-item>
        }
      </div>
    </div>
  }
</div>
